import { IKVP } from 'configs/interfaces';

export const REGION = 'europe-west3';

export const EVENTTIMEZONE = 'Europe/Berlin';

export const firebaseConfig = {
	apiKey: 'AIzaSyBix00bDuI_0UasyecnPT271dUMY-Ple3g',
	authDomain: 'bits22.firebaseapp.com',
	projectId: 'bits22',
	storageBucket: 'bits22.appspot.com',
	messagingSenderId: '610929323812',
	appId: '1:610929323812:web:22476d1c48904face94db1',
};

export const RESOLVETOKENURL = 'https://europe-west3-bits22.cloudfunctions.net/resolveUserToken';
export const BOOKSLOTURL = 'https://europe-west3-bits22.cloudfunctions.net/bookSlot';
export const CANCELSLOTURL = 'https://europe-west3-bits22.cloudfunctions.net/cancelSlot';

export const numberOfSlots = 2;
export const maximumNumberOfTableCaptains = 2;
export const EVENTCODE = 'bits22';
export const APPLICATIONURL = 'http://localhost:3001';
export const EVENTTITLE = 'Bits & Pretzels - Table Captain Booking';
export const FAVICONURL = 'https://hspxde.blob.core.windows.net/bits22/assets/bitslogo_c765a88e2b.svg';

export const CATEGORY2FILTERS: IKVP[] = [
	{
		key: 'tablecaptain',
		label: 'Table Captains',
	},
	{
		key: 'topictable',
		label: 'Topic Tables',
	},
];

export const CATEGORY3FILTERS: IKVP[] = [
	{
		key: 'IoT Data',
		label: 'IoT & Data',
	},
	{
		key: 'Investment Finances',
		label: 'Investment & Finances',
	},
	{
		key: 'Mobility',
		label: 'Mobility',
	},
	{
		key: 'ArtificialIntelligence',
		label: 'Artificial Intelligence',
	},
	{
		key: 'Marketing Communications',
		label: 'Marketing & Communications',
	},
	{
		key: 'SocialDevelopment  Impact',
		label: 'Social Development & Impact',
	},
	{
		key: 'BusinessStructures  Strategies',
		label: 'Business Structures & Strategies',
	},
	{
		key: 'Growth Scaling',
		label: 'Growth & Scaling',
	},
	{
		key: 'Leadership Empowerment',
		label: 'Leadership & Empowerment',
	},
	{
		key: 'Others',
		label: 'Others',
	},
];

export const teamCategory4: IKVP[] = [
	{
		key: 'FreeTables',
		label: 'Free Seating Area',
		order: 1,
	},
	{
		key: 'IoT Data',
		label: 'IoT & Data',
		order: 2,
	},
	{
		key: 'SaaS',
		label: 'SaaS',
		order: 3,
	},
	{
		key: 'Investment Finances',
		label: 'Investment & Finances',
		order: 4,
	},
	{
		key: 'Mobility',
		label: 'Mobility',
		order: 5,
	},
	{
		key: 'ClimateTech',
		label: 'Climate Tech',
		order: 6,
	},
	{
		key: 'ArtificialIntelligence',
		label: 'Artificial Intelligence ',
		order: 7,
	},
	{
		key: 'Marketing Communications',
		label: 'Marketing & Communications',
		order: 8,
	},
	{
		key: 'SocialDevelopment  Impact',
		label: 'Social Development & Impact',
		order: 9,
	},
	{
		key: 'BusinessStructures  Strategies',
		label: 'Business Structures & Strategies ',
		order: 10,
	},
	{
		key: 'Growth Scaling',
		label: 'Growth & Scaling',
		order: 11,
	},
	{
		key: 'Leadership Empowerment',
		label: 'Leadership & Empowerment',
		order: 12,
	},
	{
		key: 'HealthTech',
		label: 'HealthTech',
		order: 13,
	},
	{
		key: 'Entertainment Lifestyle',
		label: 'Entertainment & Lifestyle',
		order: 14,
	},
	{
		key: 'Commerce Marketplaces',
		label: 'Commerce & Marketplaces',
		order: 16,
	},
	{
		key: 'Crypto',
		label: 'Crypto',
		order: 17,
	},
	{
		key: 'Futureof Work',
		label: 'Future of Work',
		order: 18,
	},
];

export const slotTimes = ['10:00 - 10:30', '10:30 - 11:00'];
